export const CHAT_MESSAGE_STATUS = {
  sending: 'sending',
  sent: 'sent',
  received: 'received',
  read: 'read',
  0: 'read',
} as const;

export const CHAT_CONVERSATION_TYPES = {
  purchase: 'from',
  Purchase: 'From',
  sale: 'to',
  Sale: 'To',
  purchaseCodeService: 2,
  saleCodeService: 1,
} as const;

export const CHAT_MAX_NOTIFICATION_COUNTER = 99;
